module.exports = __webpack_public_path__ + "media/components/stylesheets/Gordita-Medium-738839903bf45eaed5906aeb0d593d23.woff";